import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

import { router, usePage } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

//SWIPER IMPORTS
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import { FreeMode } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";


import HeroSection from "@/components/HeroSection";
import Placeholder from "@/components/Placeholder";
import AppLayout from "@/layouts/AppLayout";
import { openModal, setItemSelected } from "@/store/slices/modalSlice";
import TransLink from "@/utils/TransLink";

import BuildYouProgram from "@/components/LandingPage/BuildYouProgram";
import WebPImage from "@/components/WebPImage";
import { colors } from "@/theme/theme";
import SEO from "@/utils/SEO";
import { Button } from "@heroui/react";
import arrow from "../assets/Arrow.svg";
import forestimage from "../assets/forest.png";
import forestimagewebp from "../assets/forest.webp";
import seaimage from "../assets/sea.png";
import seaimagewebp from "../assets/sea.webp";

interface Place {
    name: string;
    image: string;
    url: string;
    slug?: {
        key: string;
        prefix: string;
    };
    isOnWishlist?: boolean;
}

interface Accommodation {
    name: string;
    area: string;
    image: string;
    url: string;
    slug?: {
        key: string;
        prefix: string;
    };
    isOnWishlist?: boolean;
}

interface Post {
    name: string;
    description: string;
    image: string;
    url: string;
    created_at: {
        day: string;
        month: string;
    };
}

interface Events {
    area: string
    image: string
    isOnWishlist: boolean
    name: string
    slug: {
        key: string
        prefix: string
    },
    start_date: string,
    end_date: string,
}

interface Business {
    name: string;
    image: string;
    slug?: {
        key: string;
        prefix: string;
    };
    isOnWishlist?: boolean;
}

interface Props {
    social: any;
    places: { data: Place[] };
    accomodations: { data: Accommodation[] };
    posts: { data: Post[] };
    events: { data: Events[] }
    businesses: {
        nightlife?: {
            data: Business[]
        };
        restaurants?: {
            data: Business[]
        };
    }
}

interface BusinessesProps {
    nightlife: {
        data: [

        ]
    }
}


const SWIPER_BREAKPOINTS = {
    480: {
        slidesPerView: 1,
    },
    576: {
        slidesPerView: 2,
    },
    768: {

        slidesPerView: 3,
    },
    1280: {
        slidesPerView: 4,

    },
    1900: {
        slidesPerView: 5,

    }
}

const isSmallScreen = window.innerWidth < 768

const LandingPage: React.FC = () => {
    const props = usePage().props;

    console.log('props: ', props);

    const locale = props.locale;
    const dispatch = useDispatch();
    const [places, setPlaces] = useState<Place[]>([]);
    const [accomodations, setAccomodations] = useState<Accommodation[]>([]);
    const [posts, setPosts] = useState<Post[]>([]);
    const [events, setEvents] = useState<Events[]>([]);
    const [businesses, setBusinesses] = useState<Business[]>([])
    const [restaurants, setRestaurants] = useState<Business[]>([])
    const [food, setFood] = useState<Business[]>([])

    const placesSectionRef = useRef<HTMLDivElement>(null);
    const accomodationsSectionRef = useRef<HTMLDivElement>(null);
    const postsSectionRef = useRef<HTMLDivElement>(null);
    const eventsSectionRef = useRef<HTMLDivElement>(null);
    const businessesSectionRef = useRef<HTMLDivElement>(null);
    const foodSectionRef = useRef<HTMLDivElement>(null);

    const [hasLoadedPlaces, setHasLoadedPlaces] = useState(false);
    const [hasLoadedAccomodations, setHasLoadedAccomodations] = useState(false);
    const [hasLoadedPosts, setHasLoadedPosts] = useState(false);
    const [hasLoadedEvents, setHasLoadedEvents] = useState(false);
    const [hasLoadedBusinesses, setHasLoadedBusinesses] = useState(false);
    const [hasLoadedFood, setHasLoadedFood] = useState(false);

    const { t } = useTranslation(["common", "validation", "glossary"]);

    useEffect(() => {
        const onSuccess = (event: CustomEvent) => {
            console.log('event.detail.page.props', event.detail.page.props);

            const { places, accomodations, posts, events, businesses, food } = event.detail.page.props as Props;

            if (places) {
                setPlaces(places.data);
                setHasLoadedPlaces(true);
            }
            if (accomodations) {
                setAccomodations(accomodations.data);
                setHasLoadedAccomodations(true);
            }
            if (posts) {
                setPosts(posts.data);
                setHasLoadedPosts(true);
            }
            if (events) {
                setEvents(events.data);
                setHasLoadedEvents(true);
            }
            if (businesses) {
                const temp = Array.isArray(businesses?.nightlife?.data) ? businesses.nightlife.data.slice() : [];
                const tempRestaurants = Array.isArray(businesses?.restaurants?.data) ? businesses.restaurants.data.slice() : [];
                console.log('temp', temp);
                setBusinesses(temp);
                setHasLoadedBusinesses(true);
            }
            if (food) {
                console.log('food: ', food);
                setFood(food.data);
                setHasLoadedFood(true);
            }
        };

        document.addEventListener("inertia:success", onSuccess);

        return () => {
            document.removeEventListener("inertia:success", onSuccess);
        };
    }, []);

    const handleOpenLoginModal = (item) => {
        dispatch(
            setItemSelected({
                id: item.id,
                type: item.type,
            }),
        );
        dispatch(openModal("login"));
    };


    useEffect(() => {
        const options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.1,
        };

        const handleIntersection = (entries: IntersectionObserverEntry[]) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {

                    if (
                        entry.target === placesSectionRef.current &&
                        !hasLoadedPlaces
                    ) {
                        router.reload({ only: ["places"] });
                    }

                    if (
                        entry.target === accomodationsSectionRef.current &&
                        !hasLoadedAccomodations
                    ) {
                        router.reload({ only: ["accomodations"] });
                    }

                    if (
                        entry.target === eventsSectionRef.current &&
                        !hasLoadedEvents
                    ) {
                        router.reload({ only: ["events"] });
                    }

                    if (
                        entry.target === postsSectionRef.current &&
                        !hasLoadedPosts
                    ) {
                        router.reload({ only: ["posts"] });
                    }

                    if (
                        entry.target === businessesSectionRef.current &&
                        !hasLoadedBusinesses
                    ) {
                        router.reload({ only: ["businesses"] });
                    }
                    if (
                        entry.target === foodSectionRef.current &&
                        !hasLoadedFood
                    ) {
                        router.reload({ only: ["food"] });
                    }

                }
            });
        };

        const observer = new IntersectionObserver(handleIntersection, options);

        if (placesSectionRef.current)
            observer.observe(placesSectionRef.current);
        if (accomodationsSectionRef.current)
            observer.observe(accomodationsSectionRef.current);
        if (eventsSectionRef.current)
            observer.observe(eventsSectionRef.current);
        if (postsSectionRef.current) observer.observe(postsSectionRef.current);
        if (businessesSectionRef.current) observer.observe(businessesSectionRef.current);
        if (foodSectionRef.current) observer.observe(foodSectionRef.current);
        return () => {
            if (placesSectionRef.current)
                observer.unobserve(placesSectionRef.current);
            if (accomodationsSectionRef.current)
                observer.unobserve(accomodationsSectionRef.current);
            if (postsSectionRef.current)
                observer.unobserve(postsSectionRef.current);
            if (eventsSectionRef.current)
                observer.unobserve(eventsSectionRef.current);
            if (businessesSectionRef.current)
                observer.unobserve(businessesSectionRef.current);
            if (foodSectionRef.current)
                observer.unobserve(foodSectionRef.current);
        };
    }, [hasLoadedPlaces, hasLoadedAccomodations, hasLoadedPosts, hasLoadedEvents, hasLoadedBusinesses]);

    const [isSwiper, setIsSwiper] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsSwiper(places.length * 500 > window.innerWidth);
        };

        handleResize(); // Check on initial render
        window.addEventListener("resize", handleResize); // Check on window resize

        return () => window.removeEventListener("resize", handleResize); // Cleanup listener on unmount
    }, [places]);

    const MoreButton = ({ url }: { url: string }) => {

        return (
            <TransLink url={url} className="flex items-center gap-6 border border-primaryDark rounded-md md:h-[38px] px-4 hover:bg-primaryDark transition-all text-primaryDark hover:text-white group h-10">
                {t("show-more", { ns: "glossary" })}
                <svg xmlns="http://www.w3.org/2000/svg" width="5" height="10" viewBox="0 0 5 10" fill="none">
                    <path className="fill-primaryDark group-hover:fill-white transition-colors" d="M5 5L0 10L-4.37114e-07 0L5 5Z" />
                </svg>
            </TransLink>
        )

    }

    const SectionTitle = ({ title, url }: { title: string, url: string }) => {

        return (
            <div className="flex flex-row justify-between px-4 2xl:px-80 mt-20 mb-12 items-center gap-4">
                <div className="text-2xl md:text-4xl mb-2 font-bold text-primaryDark">
                    {title}
                </div>
                <MoreButton url={url} />
            </div>
        )

    }

    const WishlistStar = ({ item }: { item: any }) => {

        return (
            <svg
                className="absolute top-2 right-2 w-7 h-7 hover:cursor-pointer z-10"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() =>
                    props.isAuth === true
                        ? item.isOnWishlist
                            ? router.patch(
                                `/${locale}/wishable/delete`,
                                {
                                    slug: item
                                        ?.slug
                                        ?.key,
                                    prefix: item
                                        ?.slug
                                        ?.prefix,
                                },
                                {
                                    preserveScroll:
                                        true,
                                    onSuccess:
                                        () => {
                                            item.isOnWishlist =
                                                false;
                                        },
                                },
                            )
                            : router.patch(
                                `/${locale}/wishable/add`,
                                {
                                    slug: item
                                        ?.slug
                                        ?.key,
                                    prefix: item
                                        ?.slug
                                        ?.prefix,
                                },
                                {
                                    preserveScroll:
                                        true,
                                    onSuccess:
                                        () => {
                                            item.isOnWishlist =
                                                true;
                                        },
                                },
                            )
                        : handleOpenLoginModal(
                            item,
                        )
                }
            >
                <g id="vuesax/broken/star">
                    <g id="star">
                        <path
                            className={`absolute top-4 right-4 w-7 h-7 ${item?.isOnWishlist ? "fill-[#FFD700]" : "fill-white"}`}
                            id="Vector (Stroke)"
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12.1507 1.68699C11.9116 1.68699 11.4279 1.87873 10.9519 2.83022L8.96168 6.78782C8.74977 7.21613 8.39582 7.58212 8.03231 7.8501C7.66774 8.11885 7.21472 8.34717 6.74856 8.42587L6.74557 8.42638L3.13758 9.02237C3.13744 9.0224 3.13772 9.02235 3.13758 9.02237C2.13129 9.18922 1.80349 9.58324 1.72776 9.81903C1.65176 10.0556 1.68973 10.5664 2.41027 11.2828L5.21557 14.072C5.58025 14.4345 5.82418 14.9194 5.95869 15.3866C6.09332 15.8542 6.14367 16.3919 6.03172 16.8885L6.03046 16.8941L5.22731 20.3468C4.9282 21.632 5.23075 22.1011 5.38439 22.2125C5.53869 22.3245 6.08207 22.4679 7.22554 21.7932L10.614 19.7988C11.0846 19.5266 11.648 19.4145 12.1648 19.4145C12.6807 19.4145 13.2444 19.5263 13.7126 19.802C13.7125 19.802 13.7127 19.8021 13.7126 19.802L17.0941 21.7923C17.0938 21.7922 17.0943 21.7924 17.0941 21.7923C18.2469 22.4691 18.7897 22.3264 18.9412 22.2165C19.0913 22.1077 19.3939 21.6415 19.0936 20.3462L18.2894 16.8885C18.1774 16.3919 18.2278 15.8542 18.3624 15.3866C18.4969 14.9194 18.7409 14.4345 19.1055 14.072L21.9108 11.2828L21.9129 11.2808C22.6382 10.5645 22.6739 10.0552 22.5981 9.82056C22.5216 9.58404 22.191 9.18932 21.1835 9.02237C20.7214 8.94579 20.4091 8.51119 20.4862 8.05168C20.5632 7.59217 21.0003 7.28175 21.4625 7.35833C22.7626 7.57377 23.8572 8.20249 24.2134 9.30432C24.5701 10.4076 24.0465 11.551 23.1097 12.4766C23.1093 12.477 23.1089 12.4773 23.1086 12.4777L20.3053 15.2648C20.1949 15.3746 20.0712 15.5814 19.9936 15.8509C19.9165 16.1187 19.91 16.3616 19.9446 16.5174C19.9447 16.5181 19.9449 16.5188 19.9451 16.5196L20.7469 19.9667C21.0801 21.4043 20.9699 22.8338 19.9408 23.5797C18.9131 24.3246 17.5099 23.9958 16.2311 23.2448L12.8482 21.2537C12.7056 21.1697 12.4603 21.1015 12.1648 21.1015C11.8714 21.1015 11.6213 21.1686 11.4695 21.2557C11.4688 21.2562 11.468 21.2566 11.4673 21.257L8.09148 23.2439C6.81426 23.9975 5.41203 24.3209 4.38426 23.5753C3.35586 22.8292 3.23988 21.4032 3.57419 19.9667C3.57419 19.9667 3.5742 19.9667 3.57419 19.9667L4.37605 16.5196C4.37621 16.5188 4.37637 16.5181 4.37654 16.5174C4.41109 16.3616 4.40457 16.1187 4.32747 15.8509C4.24989 15.5814 4.12619 15.3746 4.01578 15.2648L1.21049 12.4757C0.279537 11.5501 -0.242429 10.4076 0.111419 9.30585C0.465525 8.20332 1.55768 7.57391 2.85864 7.35833L6.4645 6.76269C6.46489 6.76262 6.46529 6.76255 6.46569 6.76249C6.5991 6.73966 6.8072 6.65311 7.02172 6.49497C7.23697 6.33629 7.37982 6.16366 7.43958 6.04236L7.44264 6.03615L9.43272 2.07893C9.4326 2.07918 9.43284 2.07869 9.43272 2.07893C10.0314 0.882694 10.9675 0 12.1507 0C13.3326 0 14.2712 0.880447 14.8755 2.07577L14.8763 2.07735L16.8671 6.03616L16.8743 6.05074C16.9191 6.14424 17.0286 6.28627 17.1964 6.42133C17.5606 6.71445 17.6168 7.24558 17.322 7.60766C17.0272 7.96974 16.493 8.02565 16.1288 7.73254C15.8238 7.48702 15.5281 7.15969 15.3463 6.78429L13.3595 2.83338C13.3593 2.83316 13.3596 2.83359 13.3595 2.83338C12.8779 1.88116 12.3911 1.68699 12.1507 1.68699Z"
                        />
                    </g>
                </g>
            </svg>
        )
    }

    const SwiperWrapper = ({ dataLength, children }: { dataLength: number, children: any }) => {

        const swiperRef = useRef(null);

        useLayoutEffect(() => {
            if (swiperRef.current) {
                // Wait a bit to ensure layout is ready

                if ((window.innerWidth > 768 && window.innerWidth < 1900) || (window.innerWidth >= 1900 && dataLength > 5)) {
                    swiperRef.current.setTranslate(-200); // scrolls right by 100px
                }
            }
        }, []);

        return (
            <Swiper
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
                breakpoints={SWIPER_BREAKPOINTS}
                pagination={{
                    dynamicBullets: true,
                }}
                lazy={true}
                freeMode={true}
                spaceBetween={30}
                modules={[
                    //   Pagination,
                    FreeMode
                ]}
                className="!mx-4 !pb-10"
                style={{
                    "--swiper-pagination-bullet-inactive-color": "#999999",
                    "--swiper-pagination-color": colors.primary,
                    "--swiper-pagination-bullet-inactive-opacity": "1",
                    "--swiper-pagination-bullet-size": "12px",
                    "--swiper-pagination-bullet-horizontal-gap": "2px",
                }}


            >
                {children}
            </Swiper>
        )
    }

    const PlaceName = ({ name }: { name: string }) => {
        return (
            <span className="absolute bottom-2 font-semibold left-2 text-white text-xl [text-shadow:2px_2px_4px_rgba(0,0,0,0.4),-2px_-2px_4px_rgba(0,0,0,0.4),2px_-2px_4px_rgba(0,0,0,0.4),-2px_2px_4px_rgba(0,0,0,0.4)]">
                {name}
            </span>
        )
    }

    return (
        <AppLayout>
            <div className="space-y-14 bg-gray-50">
                <SEO seo={props.seo} />
                <section>
                    <HeroSection social={props.social} />
                </section>

                <section className="bg-gray-50 lg:py-8 xl:px-32 px-0 flex flex-wrap md:flex-wrap-reverse justify-center !mt-0 md:mt-14 ">
                    <div className="relative w-full md:w-[500px] md:h-[500px] h-[500px] p-8 order-2 md:order-1">
                        <div className="absolute w-[300px] top-0 xl:mt-0 mt-12 left-0  h-[300px] rounded-lg flex items-center justify-center z-10">
                            <WebPImage
                                className="w-full h-full object-cover rounded-lg"
                                srcWebP={forestimagewebp}
                                srcFallback={forestimage}
                                alt="My image description"
                            />
                        </div>
                        <div className="absolute w-[300px] bottom-0 right-0  h-[300px] rounded-lg flex items-center justify-center z-20">
                            <WebPImage
                                className="w-full h-full object-cover rounded-lg"
                                srcWebP={seaimagewebp}
                                srcFallback={seaimage}
                                alt="My image description"
                            />
                        </div>
                    </div>
                    <div className="w-full md:w-2/3 lg:w-1/2 md:ml-4 md:m-0 m-4 mt-8 md:mt-0 order-1 md:order-2">
                        <div className="flex">
                            <h1 className="md:text-5xl text-4xl font-bold text-[#1D24CA] mb-2">
                                {t("thassos", { ns: "glossary" })}
                            </h1>
                            <div className="w-28 ml-6 h-1 mt-6 bg-[#1D24CA]"></div>
                        </div>
                        <h2 className="xl:text-3xl text-2xl mb-4 font-extralight">
                            {t("the_emerald_island", { ns: "glossary" })}
                        </h2>
                        <p className="text-lg leading-7 ml-0 md:ml-32 font-light mb-4">
                            {t("island_of_sirens", { ns: "glossary" })}
                        </p>
                        <p className="text-lg leading-7 font-light ml-0 md:ml-32 mb-4">
                            {t("enjoy_the_hospitality", { ns: "glossary" })}
                        </p>
                        <TransLink url="search?isMapView=true&page=1&searchScope[]=Place">
                            <Button
                                title={t("explore_thasos", { ns: "glossary" })}
                                className="mt-4 px-6 py-3 mx-auto md:ml-32 bg-primaryDark text-white font-bold rounded-md transition duration-300 ease-in-out hover:bg-blue-700 hover:shadow-lg block md:inline-block">
                                {t("explore_thasos", { ns: "glossary" })}
                            </Button>
                        </TransLink>
                    </div>
                </section>

                {/* Αξιοθέατα */}

                {places &&
                    <section className="bg-gray-50" ref={placesSectionRef}>

                        <SectionTitle title={t("Place", { ns: "glossary" })} url="/search?isMapView=true&page=1&searchScope%5B0%5D=Place" />
                        {places.length === 0 && hasLoadedPlaces && <h2 className="text-center lg:text-3xl text-xl">{t("no-items", { ns: "glossary" })}</h2>}
                        {!hasLoadedPlaces ? (
                            <Placeholder length={4} />
                        ) : isSwiper && (places.length > 4 || isSmallScreen || (places.length === 4 && window.innerWidth < 1200)) ? (
                            <SwiperWrapper dataLength={places.length}>
                                {places.map((place, index) => (
                                    <SwiperSlide key={index}>

                                        <div className="relative rounded-xl bg-black w-full h-full">
                                            <WishlistStar item={place} />
                                            {place.image ? (
                                                <img
                                                    loading="lazy"
                                                    src={place.image}
                                                    className="w-full h-[215px] opacity-[80%] object-cover object-center rounded-lg"
                                                />
                                            ) : (
                                                <div className="w-full h-[215px] bg-gray-300 rounded-lg flex items-center justify-center"></div>
                                            )}
                                            <PlaceName name={place.name} />
                                            <TransLink
                                                url={`${place.slug?.prefix}/${place.slug?.key}`}
                                                className="absolute bottom-2 right-2"
                                            >
                                                <img
                                                    loading="lazy"
                                                    src={arrow}
                                                    className="w-full h-full object-cover rounded-lg"
                                                />
                                            </TransLink>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </SwiperWrapper>
                        ) : (
                            <div className="flex justify-center space-x-4 mx-4">
                                {places.map(
                                    (place, index) => (

                                        (
                                            <div
                                                className="relative rounded-xl w-[400px] bg-black"
                                                key={index}
                                            >
                                                <WishlistStar item={place} />
                                                {place.image ? (
                                                    <img
                                                        src={place.image}
                                                        className="w-full h-[215px] opacity-[80%] object-cover object-center rounded-lg"
                                                    />
                                                ) : (
                                                    <div className="w-full h-[215px] bg-gray-300 rounded-lg flex items-center justify-center"></div>
                                                )}
                                                <div className="absolute bottom-2 flex flex-row justify-between w-full px-2 items-center">
                                                    <span className=" font-semibold left-2 text-white text-xl">
                                                        {place.name}
                                                    </span>
                                                    <TransLink
                                                        url={`${place.slug?.prefix}/${place.slug?.key}`}
                                                        className=""
                                                    >
                                                        <img
                                                            src={arrow}
                                                            className="w-full h-full object-cover rounded-lg"
                                                        />
                                                    </TransLink>

                                                </div>

                                            </div>
                                        )
                                    ),
                                )}
                            </div>
                        )}
                    </section>}

                {/* Εκδηλώσεις */}

                {events && <section ref={eventsSectionRef}>

                    <SectionTitle title={t("events", { ns: "glossary" })} url="/search?isMapView=true&page=1&searchScope%5B0%5D=Event" />
                    {events.length === 0 && hasLoadedEvents && <h2 className="text-center text-xl lg:text-3xl">{t("no-items", { ns: "glossary" })}</h2>}
                    {!hasLoadedEvents ? (
                        <Placeholder length={4} />
                    ) :
                        (events?.length > 4 || isSmallScreen || (events.length === 4 && window.innerWidth < 1200)) ? (
                            <SwiperWrapper dataLength={events.length}>

                                {events.map(
                                    (event, index) => (

                                        (
                                            <SwiperSlide
                                                className="relative bg-white rounded-2xl shadow-lg overflow-hidden"
                                                key={index}
                                            >

                                                <WishlistStar item={event} />

                                                {event.image ? (
                                                    <img
                                                        src={event.image}
                                                        alt={event.name}
                                                        className="w-full h-[526px] object-cover object-center"
                                                    />
                                                ) : (
                                                    <div className="w-full h-[526px] bg-gray-300 flex items-center justify-center"></div>
                                                )}
                                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 flex flex-col ">
                                                    <span className="text-white text-2xl font-semibold mb-4 [text-shadow:2px_2px_4px_rgba(0,0,0,0.4),-2px_-2px_4px_rgba(0,0,0,0.4),2px_-2px_4px_rgba(0,0,0,0.4),-2px_2px_4px_rgba(0,0,0,0.4)]">
                                                        <TransLink
                                                            url={`${event.slug?.prefix}/${event.slug?.key}`}
                                                        >
                                                           {event.name}
                                                        </TransLink>
                                                    </span>
                                                    <div className="flex flex-row justify-between">
                                                        <span className="text-white text-md lg:text-2xl content-center">
                                                            {event.start_date && event.end_date
                                                                ? `${new Date(event.start_date).toLocaleDateString('el-GR')} - ${new Date(event.end_date).toLocaleDateString('el-GR')}`
                                                                : event.start_date
                                                                    ? new Date(event.start_date).toLocaleDateString('el-GR')
                                                                    : ''}
                                                        </span>
                                                        <TransLink
                                                            url={`${event.slug?.prefix}/${event.slug?.key}`}

                                                        >
                                                            <img
                                                                loading="lazy"
                                                                src={arrow}
                                                                className="w-full h-full object-cover rounded-lg"
                                                            />
                                                        </TransLink>
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        )
                                    )
                                )}

                            </SwiperWrapper>
                        ) : (
                            <div className="flex justify-center space-x-4 mx-4">
                                {events.map(
                                    (event, index) => (

                                        (
                                            <div
                                                className="relative bg-white rounded-2xl shadow-lg w-[420px] "
                                                key={index}
                                            >


                                                <WishlistStar item={event} />

                                                {event.image ? (
                                                    <img
                                                        src={event.image}
                                                        alt={event.name}
                                                        className="w-full h-[526px] object-cover object-center rounded-xl"
                                                    />
                                                ) : (
                                                    <div className="w-full h-[526px] bg-gray-300 flex items-center justify-center"></div>
                                                )}
                                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 flex flex-col rounded-xl p-2">
                                                    <span className="text-white text-lg 2xl:text-2xl font-semibold mb-4 [text-shadow:2px_2px_4px_rgba(0,0,0,0.4),-2px_-2px_4px_rgba(0,0,0,0.4),2px_-2px_4px_rgba(0,0,0,0.4),-2px_2px_4px_rgba(0,0,0,0.4)]">
                                                        <TransLink
                                                            url={`${event.slug?.prefix}/${event.slug?.key}`}
                                                        >
                                                           {event.name}
                                                        </TransLink>
                                                    </span>
                                                    <div className="flex flex-row justify-between">
                                                        <span className="text-white text-md 2xl:text-2xl">
                                                            {event.start_date && event.end_date
                                                                ? `${new Date(event.start_date).toLocaleDateString('el-GR')} - ${new Date(event.end_date).toLocaleDateString('el-GR')}`
                                                                : event.start_date
                                                                    ? new Date(event.start_date).toLocaleDateString('el-GR')
                                                                    : ''}
                                                        </span>
                                                        <TransLink
                                                            url={`${event.slug?.prefix}/${event.slug?.key}`}

                                                        >
                                                            <img
                                                                loading="lazy"
                                                                src={arrow}
                                                                className="w-full h-full object-cover rounded-lg overflow-visible"
                                                            />
                                                        </TransLink>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    )
                                )}
                            </div>
                        )}
                </section>}

                {/* Ποτό και Νυχτερινή ζωή */}

                {businesses &&
                    <section ref={businessesSectionRef}>
                        <SectionTitle title={t("drinks_night_life", { ns: "glossary" })} url="/search?isMapView=true&page=1&business_types[0]=poto-kai-nikhterini-zoi&searchScope[0]=Business" />
                        {businesses.length === 0 && hasLoadedBusinesses && <h2 className="text-center text-xl lg:text-3xl">{t("no-items", { ns: "glossary" })}</h2>}

                        {!hasLoadedBusinesses ? (
                            <Placeholder length={4} />
                        ) : isSwiper && (businesses.length > 4 || (businesses.length === 4 && window.innerWidth < 1200)) ? (
                            <SwiperWrapper dataLength={businesses.length}>
                                {businesses.map((place, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="relative rounded-xl bg-black w-full h-full">
                                            <WishlistStar item={place} />
                                            {place.image ? (
                                                <img
                                                    loading="lazy"
                                                    src={place.image}
                                                    className="w-full h-[215px] opacity-[80%] object-cover object-center rounded-lg"
                                                />
                                            ) : (
                                                <div className="w-full h-[215px] bg-gray-300 rounded-lg flex items-center justify-center"></div>
                                            )}
                                            <PlaceName name={place.name} />
                                            <TransLink
                                                url={`${place.slug?.prefix}/${place.slug?.key}`}
                                                className="absolute bottom-2 right-2"
                                            >
                                                <img
                                                    loading="lazy"
                                                    src={arrow}
                                                    className="w-full h-full object-cover rounded-lg"
                                                />
                                            </TransLink>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </SwiperWrapper>
                        ) : (
                            <div className="flex justify-center space-x-4 mx-4">
                                {businesses.map(
                                    (place, index) => (
                                        (
                                            <div
                                                className="relative rounded-xl w-[400px] bg-black"
                                                key={index}
                                            >
                                                <WishlistStar item={place} />
                                                {place.image ? (
                                                    <img
                                                        src={place.image}
                                                        className="w-full h-[215px] opacity-[80%] object-cover object-center rounded-lg"
                                                    />
                                                ) : (
                                                    <div className="w-full h-[215px] bg-gray-300 rounded-lg flex items-center justify-center"></div>
                                                )}
                                                <PlaceName name={place.name} />
                                                <TransLink
                                                    url={`${place.slug?.prefix}/${place.slug?.key}`}
                                                    className="absolute bottom-2 right-2"
                                                >
                                                    <img
                                                        src={arrow}
                                                        className="w-full h-full object-cover rounded-lg"
                                                    />
                                                </TransLink>
                                            </div>
                                        )
                                    ),
                                )}
                            </div>
                        )}
                    </section>}

                {/* Φαγητό */}
                {food &&
                    <section ref={foodSectionRef}>
                        <SectionTitle title={t("food", { ns: "glossary" })} url="/search?isMapView=true&page=1&?business_types[0]=faghito&searchScope[0]=Business" />
                        {food.length === 0 && hasLoadedFood && <h2 className="text-center text-xl lg:text-3xl">{t("no-items", { ns: "glossary" })}</h2>}

                        {!hasLoadedFood ? (
                            <Placeholder length={4} />
                        ) : isSwiper && (food.length > 4 || isSmallScreen || (food.length === 4 && window.innerWidth < 1200)) ? (
                            <SwiperWrapper dataLength={food.length}>
                                {food.map((place, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="relative rounded-xl bg-black w-full h-full">
                                            <WishlistStar item={place} />
                                            {place.image ? (
                                                <img
                                                    loading="lazy"
                                                    src={place.image}
                                                    className="w-full h-[215px] opacity-[80%] object-cover object-center rounded-lg"
                                                />
                                            ) : (
                                                <div className="w-full h-[215px] bg-gray-300 rounded-lg flex items-center justify-center"></div>
                                            )}
                                            <PlaceName name={place.name} />
                                            <TransLink
                                                url={`${place.slug?.prefix}/${place.slug?.key}`}
                                                className="absolute bottom-2 right-2"
                                            >
                                                <img
                                                    loading="lazy"
                                                    src={arrow}
                                                    className="w-full h-full object-cover rounded-lg"
                                                />
                                            </TransLink>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </SwiperWrapper>
                        ) : (
                            <div className="flex justify-center space-x-4 mx-4">
                                {food.map(
                                    (place, index) => (

                                        (
                                            <div
                                                className="relative rounded-xl w-[400px] bg-black"
                                                key={index}
                                            >
                                                <WishlistStar item={place} />
                                                {place.image ? (
                                                    <img
                                                        src={place.image}
                                                        className="w-full h-[215px] opacity-[80%] object-cover object-center rounded-lg"
                                                    />
                                                ) : (
                                                    <div className="w-full h-[215px] bg-gray-300 rounded-lg flex items-center justify-center"></div>
                                                )}
                                                <PlaceName name={place.name} />
                                                <TransLink
                                                    url={`${place.slug?.prefix}/${place.slug?.key}`}
                                                    className="absolute bottom-2 right-2"
                                                >
                                                    <img
                                                        src={arrow}
                                                        className="w-full h-full object-cover rounded-lg"
                                                    />
                                                </TransLink>


                                            </div>
                                        )
                                    ),
                                )}
                            </div>
                        )}
                    </section>}

                {/* Διαμονή */}

                {accomodations &&
                    <section
                        className="bg-gray-50 "
                        ref={accomodationsSectionRef}
                    >
                        <SectionTitle title={t("accommodation_in_thassos", { ns: "glossary" })} url="/search?isMapView=true&page=1&searchScope%5B0%5D=Accomodation" />
                        {accomodations.length === 0 && hasLoadedAccomodations && <h2 className="text-center text-xl lg:text-3xl">{t("no-items", { ns: "glossary" })}</h2>}

                        {!hasLoadedAccomodations ? (
                            <Placeholder length={4} />
                        ) : (accomodations.length > 4 || isSmallScreen || (accomodations.length === 4 && window.innerWidth < 1200)) ? (
                            <SwiperWrapper dataLength={accomodations.length}>
                                {accomodations.map(
                                    (accommodation, index) => (

                                        (
                                            <SwiperSlide
                                                className="relative bg-white rounded-2xl shadow-lg overflow-hidden"
                                                key={index}
                                            >
                                                <WishlistStar item={accommodation} />

                                                {accommodation.image ? (
                                                    <img
                                                        src={accommodation.image}
                                                        alt={accommodation.name}
                                                        className="h-[400px] object-cover object-center w-full"
                                                    />
                                                ) : (
                                                    <div className="h-[400px] bg-gray-300 flex items-center justify-center"></div>
                                                )}
                                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 flex flex-col items-center">
                                                        <span className="text-white font-medium text-lg [text-shadow:2px_2px_4px_rgba(0,0,0,0.4),-2px_-2px_4px_rgba(0,0,0,0.4),2px_-2px_4px_rgba(0,0,0,0.4),-2px_2px_4px_rgba(0,0,0,0.4)]">
                                                            {accommodation.area}
                                                        </span>
                                                    <span className="text-white text-2xl font-semibold [text-shadow:2px_2px_4px_rgba(0,0,0,0.4),-2px_-2px_4px_rgba(0,0,0,0.4),2px_-2px_4px_rgba(0,0,0,0.4),-2px_2px_4px_rgba(0,0,0,0.4)]">
                                                        <TransLink
                                                            url={`${accommodation.slug?.prefix}/${accommodation.slug?.key}`}
                                                        >
                                                            {accommodation.name}
                                                        </TransLink>
                                                    </span>
                                                    <TransLink
                                                        url={`${accommodation.slug?.prefix}/${accommodation.slug?.key}`}
                                                        className="mt-2  text-white border rounded-full flex items-center hover:bg-[#1D24CA] hover:text-white justify-center transition"
                                                    >
                                                        <div className="mx-4 font-semibold">
                                                            {t('glossary:book_now')}
                                                        </div>
                                                        <span>
                                                            <img
                                                                src={arrow}
                                                                className="w-full h-full object-cover rounded-lg"
                                                            />
                                                        </span>
                                                    </TransLink>
                                                </div>
                                            </SwiperSlide>
                                        )
                                    ),
                                )}
                            </SwiperWrapper>
                        ) : (
                            <div className="flex justify-center space-x-4 mx-4">
                                {accomodations.map(
                                    (place, index) => (

                                        (
                                            <div
                                                className="relative rounded-xl w-[400px] bg-black"
                                                key={index}
                                            >
                                                <WishlistStar item={place} />
                                                {place.image ? (
                                                    <img
                                                        src={place.image}
                                                        className="w-full h-[215px] opacity-[80%] object-cover object-center rounded-lg"
                                                    />
                                                ) : (
                                                    <div className="w-full h-[215px] bg-gray-300 rounded-lg flex items-center justify-center"></div>
                                                )}
                                                <div className="absolute bottom-2 flex flex-row justify-between w-full px-2 items-center">
                                                    <span className="font-semibold left-2 text-white text-xl [text-shadow:2px_2px_4px_rgba(0,0,0,0.4),-2px_-2px_4px_rgba(0,0,0,0.4),2px_-2px_4px_rgba(0,0,0,0.4),-2px_2px_4px_rgba(0,0,0,0.4)]">
                                                        {place.name}
                                                    </span>
                                                    <TransLink
                                                        url={`${place.slug?.prefix}/${place.slug?.key}`}
                                                        className="right-2"
                                                    >
                                                        <img
                                                            src={arrow}
                                                            className="w-full h-full object-cover rounded-lg"
                                                        />
                                                    </TransLink>
                                                </div>

                                            </div>
                                        )
                                    ),
                                )}
                            </div>
                        )}
                    </section>}

                <section className="pb-14 mx-4">
                    <BuildYouProgram />
                </section>


            </div>



        </AppLayout>
    );
};

export default LandingPage;
